import React from "react";

import { alertStyle, alertVariants } from "./alert.css";

export function Alert({ variant = "alert", children }) {
  return (
    <div className={`${alertStyle} ${alertVariants[variant]}`}>{children}</div>
  );
}
